import React, {Component} from 'react'
import PropTypes from 'prop-types';
import { Segment, Icon, Label, Button, Grid, Message, Header } from 'semantic-ui-react';
import { ACCOUNT_APP_ADD_VEHICLE, accountAppUrl } from '../../../modules/accountApp';

const clickable ={ 'display': 'block' };

const NoVehicles = (props) => {
    return (
        <Segment disabled secondary textAlign='center'>
            <a href={accountAppUrl(ACCOUNT_APP_ADD_VEHICLE)} style={clickable}>
                <Header as='h4' icon>
                    <Icon name='car' />
                        You have no registered vehicles
                    <Header.Subheader>
                        Click here to add one
                    </Header.Subheader>
                </Header>
            </a>
        </Segment>
    );
};

export default NoVehicles;
